import { ProductLifecycleStage, Stage } from 'src/shared/types/product';

const stageMap: Record<string, string> = {
  rfq_received: 'quoting',
  rfq_sent: 'quoting',
  quotes_received: 'quoting',
  samples_ordered: 'sampling',
  samples_produced: 'sampling',
  ordered: 'ordering',
  order_produced: 'ordering'
};

const getStageFromLifecycle = (
  lifecycle: ProductLifecycleStage[]
): Stage | null => {
  if (lifecycle) {
    const activeStatus = lifecycle.find(
      (item) => item.status === 'ongoing' || item.status === 'blocked'
    );

    const pendingStatus = lifecycle.find((item) => item.status === 'pending');

    const relevantStage = activeStatus ?? pendingStatus;

    if (relevantStage?.id) {
      return stageMap[relevantStage.id] as Stage;
    }

    const allStagesDone = lifecycle.every((item) => item.status === 'done');
    const orderProducedStage = lifecycle.find(
      (item) => item.id === 'order_produced'
    );

    if (allStagesDone && orderProducedStage?.status === 'done') {
      return 'delivered';
    }

    return 'draft';
  }

  return null;
};

export default getStageFromLifecycle;
